import React from 'react';
import { render, screen } from '@testing-library/react';

import ConfigProvider from 'components/ConfigProvider';

import AuthenticationCell from './AuthenticationCell';
import EMPTY_VALUE from '../../shared/emptyValue';

const renderCell = (authentication) =>
  render(
    <ConfigProvider>
      <AuthenticationCell authentication={authentication} />
    </ConfigProvider>,
  );

describe('management/Users AuthenticationCell', () => {
  it("names the user's identity provider", () => {
    renderCell({
      assignment: 'manual',
      provider: 'paccar',
      label: 'PCAR (Pass)',
    });

    expect(screen.getByText('PCAR (Pass)')).toBeInTheDocument();
  });

  it('names password login, which is a state and not a gap', () => {
    renderCell({ assignment: null, provider: null, label: 'Password' });

    expect(screen.getByText('Password')).toBeInTheDocument();
    expect(screen.queryByText(EMPTY_VALUE)).not.toBeInTheDocument();
  });

  // Both are the same fact to read off a list: which provider this user signs in
  // with. Where the assignment came from only matters where it can be acted on,
  // which is the edit form.
  it('draws a domain-assigned provider the same as a manual one', () => {
    const { container: domain } = renderCell({
      assignment: 'domain',
      provider: 'decisiv',
      label: 'Decisiv Okta',
    });
    const domainMarkup = domain.innerHTML;

    const { container: manual } = renderCell({
      assignment: 'manual',
      provider: 'decisiv',
      label: 'Decisiv Okta',
    });

    expect(manual.innerHTML).toEqual(domainMarkup);
  });

  it('falls back to the placeholder when the server sent nothing', () => {
    renderCell(null);

    expect(screen.getByText(EMPTY_VALUE)).toBeInTheDocument();
  });

  it('falls back to the placeholder for a payload with no label', () => {
    renderCell({ assignment: null, provider: null });

    expect(screen.getByText(EMPTY_VALUE)).toBeInTheDocument();
  });
});
